import React from "react"
import "./AboutMe.css"
import AboutImg from "../../assets/about-us.jpg"

function AboutMe() {
    return (
        <section id="Aboutus">
            <div className="container">
                <div className="about-contents">
                    <div className="aboutImage">
                        <img src={AboutImg} alt="about us" />
                    </div>
                    <div className="aboutDetails">
                        <div className="tiltedesc">
                            <h1>About me</h1>
                            <p>Hello! I'm Md Nazmul Hossain, a professional front-end developer with a passion for creating a website using React JS. Specializing in web applications, I thrive on transforming ideas into functional and user-friendly products. With a strong foundation in JavaScript, I enjoy leveraging its power to craft dynamic and interactive experiences across platforms.

                            Currently, I am studying for a bachelor's degree in computer science engineering at Southeast University. Through my studies and practical experience, I am honing my skills to contribute meaningfully to the tech industry. I am enthusiastic about making the web more accessible and engaging for users worldwide.

                            I am available for any kind of job opportunity that suits my interests.
                            </p>
                        </div>
                        <div className="about-more">
                            <a href="https://www.linkedin.com/in/nazmul-hossain-rdo/" target="_blank" rel="noreferrer">MORE....</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default AboutMe;
